<script setup lang="ts">
import { computed } from 'vue';
import { EMPTY_FIELD_SIGN } from '../forms/utils.ts';
import type { DateTimeFormatterProps } from './types';
import { getDateTimeFormatted } from './utils';

const props = defineProps<DateTimeFormatterProps>();
const datetime = computed(() => getDateTimeFormatted(props));

const splittedDateTime = computed(() => datetime.value?.split('T'));
</script>

<template>
  <span data-testid="dateTimeFormatter">
    <span v-if="typeof value === 'undefined'">{{ EMPTY_FIELD_SIGN }}</span>
    <span v-else-if="format === 'iso' && splittedDateTime?.length === 2">
      {{ splittedDateTime[0] }}&ZeroWidthSpace;T{{ splittedDateTime[1] }}
    </span>
    <span v-else>{{ datetime }}</span>
  </span>
</template>
